var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 29,
    width: 96,
    height: 12,
    fill: "#00C3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16912 36H15.4783L23.6475 10.9194H17.3773L11.8237 29.3715L6.27016 10.9194H0L8.16912 36Z",
    fill: "#032436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6793 36.5016C34.0799 36.5016 35.8355 35.6775 37.0179 34.316V36H42.3923V18.0853H37.0179V19.7692C35.8355 18.4077 34.0799 17.5837 31.6793 17.5837C26.9857 17.5837 23.1161 21.704 23.1161 27.0426C23.1161 32.3812 26.9857 36.5016 31.6793 36.5016ZM28.4905 27.0426C28.4905 24.3554 30.282 22.6714 32.7542 22.6714C35.2264 22.6714 37.0179 24.3554 37.0179 27.0426C37.0179 29.7298 35.2264 31.4138 32.7542 31.4138C30.282 31.4138 28.4905 29.7298 28.4905 27.0426Z",
    fill: "#032436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8578 36H52.2322V9.84448H46.8578V36Z",
    fill: "#032436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6349 18.0853H68.2605V27.8667C68.2605 30.4106 66.8989 31.5571 64.9283 31.5571C63.2085 31.5571 61.8112 30.5181 61.8112 28.2967V18.0853H56.4367V29.0849C56.4367 33.9219 59.5181 36.5016 63.1369 36.5016C65.5016 36.5016 67.2931 35.6417 68.2605 34.316V36H73.6349V18.0853Z",
    fill: "#032436"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.128 36.5016C90.5318 36.5016 93.1831 35.2476 94.9388 32.8112L90.6392 30.3389C89.9227 31.1272 88.6686 31.7005 87.1996 31.7005C85.229 31.7005 83.5808 31.0555 82.9001 29.1924H95.6195C95.7629 28.5116 95.8345 27.795 95.8345 27.0426C95.8345 21.6324 91.9649 17.5837 86.7338 17.5837C81.0728 17.5837 77.2032 21.704 77.2032 27.0426C77.2032 32.3812 81.0011 36.5016 87.128 36.5016ZM82.7926 25.1795C83.2942 23.3522 84.6557 22.349 86.698 22.349C88.3103 22.349 89.9227 23.1014 90.4959 25.1795H82.7926Z",
    fill: "#032436"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.424 10.9194H97.793V16.4371H104.242V36H109.975V16.4371H116.424V10.9194Z",
    fill: "#032436"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.087 36.5016C128.491 36.5016 131.142 35.2476 132.898 32.8112L128.598 30.3389C127.882 31.1272 126.628 31.7005 125.159 31.7005C123.188 31.7005 121.54 31.0555 120.859 29.1924H133.579C133.722 28.5116 133.794 27.795 133.794 27.0426C133.794 21.6324 129.924 17.5837 124.693 17.5837C119.032 17.5837 115.162 21.704 115.162 27.0426C115.162 32.3812 118.96 36.5016 125.087 36.5016ZM120.752 25.1795C121.253 23.3522 122.615 22.349 124.657 22.349C126.27 22.349 127.882 23.1014 128.455 25.1795H120.752Z",
    fill: "#032436"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.365 36H142.739V28.0817L148.472 36H154.563L147.863 27.0426L154.384 18.0853H148.113L142.739 25.9319V10.9194H137.365V36Z",
    fill: "#032436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d08124f15f0ba45759a86f506ee7ce8e.svg";
export { ForwardRef as ReactComponent };